export function ModuleIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.966 4.78702C17.129 4.88483 17.2638 5.0232 17.3574 5.18864C17.451 5.35408 17.5001 5.54095 17.5 5.73102V10.37L12 13.908L6.5 10.37V5.73102C6.49986 5.54095 6.54898 5.35408 6.64257 5.18864C6.73616 5.0232 6.87102 4.88483 7.034 4.78702L11.434 2.14702C11.605 2.04443 11.8006 1.99023 12 1.99023C12.1994 1.99023 12.395 2.04443 12.566 2.14702L16.966 4.78702Z"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 8.4082V13.9082"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.5 17.2081L12 13.9081M12 13.9081L17.5 10.3701L22.5 13.5831C22.6539 13.6833 22.7803 13.8204 22.8677 13.982C22.955 14.1436 23.0005 14.3245 23 14.5081V18.5701C23.0005 18.7538 22.955 18.9347 22.8677 19.0962C22.7803 19.2578 22.6539 19.3949 22.5 19.4951L18.1 22.3251C17.9225 22.4392 17.716 22.4999 17.505 22.4999C17.294 22.4999 17.0875 22.4392 16.91 22.3251L12 19.1701V13.9081Z"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.5 17.208V22.5"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 13.9081V19.1701L7.1 22.3251C6.92254 22.4392 6.716 22.4999 6.505 22.4999C6.29401 22.4999 6.08747 22.4392 5.91 22.3251L1.51 19.4951C1.35421 19.3961 1.22584 19.2595 1.13671 19.0978C1.04759 18.9362 1.00057 18.7547 1 18.5701V14.5081C0.999496 14.3245 1.04499 14.1436 1.13232 13.982C1.21966 13.8204 1.34606 13.6833 1.5 13.5831L6.5 10.3701L12 13.9081ZM12 13.9081L6.5 17.2081"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.49986 17.2078L1.13086 13.9868"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.5 17.208V22.5"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0001 8.40789L6.64111 5.19189"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.359 5.19189L12 8.40789"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.869 13.9868L17.5 17.2078"
                stroke="currentcolor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
